import React from "react";

function Header({ titik, setTitik, classNav }) {
  return (
    <header className="dark:text-gray-200">
      <h1 className=" text-2xl md:text-3xl font font-semibold mb-2" id="typing">
        🙋Halloo...
      </h1>
      <h1 className="text-2xl md:text-3xl font font-semibold mb-2">
        Kenalin Saya Mukhammad Nur Mubin (@mubinn_mhd)
      </h1>
      <p className="text-lg md:text-xl font-normal">
        Lulusan akuntansi yang senang programming,{" "}
        <span className="text-pink-500 dark:text-pink-500 font-semibold">
          sering disuruh hack facebook teman,
        </span>{" "}
        tapi gak pernah berhasil, kalo kata teman sih saya pendiam, seneng
        belajar hal baru dan lumayan suka tantangan{" "}
        <button
          className="underline decoration-sky-500 underline-offset-4 decoration-4"
          onClick={() => setTitik("salam kenaal😁")}
        >
          {titik}
        </button>
      </p>
    </header>
  );
}

export default Header;
